﻿$.fn.dxCtrlSaisieSociete = function custom_dxCtrlSaisieSociete(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisiesociete dx-ctrl")
        this.createInstance(new cdxCtrlSaisieSociete(this, option));
    }
    return this;
}


window.cdxCtrlSaisieSociete = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (name == "value") {
            if (typeof value == 'undefined') {
                return option[name];
            }
            else {
                option[name] = value;
                mConstruit()
            }
        } else {
            if (typeof value == 'undefined') {
                return dx.option(name);
            }
            else {
                dx.option(name, value);
            }
        }

    }

    if (!option.lstObligatoire) option.lstObligatoire = []

    var disableValueChanged = false
    var dxNomSociete = null
    var dxSiret = null
    var dxTvaIntra = null
    function mConstruit() {
        container.empty();
        dxNomSociete = null
        dxSiret = null
        dxTvaIntra = null
        //var $TableSociete = $("<table style='width:100%;'/>").appendTo(container)
        //var $Tr = $("<tr/>").appendTo($TableSociete)
        //var $Td = $("<td style='width:100%' colspan='2'/>").appendTo($Tr)

        switch (parseInt(option.value.id_type_client)) {
            case 0: break;
            case 1:
                dxNomSociete = $("<div style='padding:5px 0;'/>").appendTo(container).dxCtrlTextBoxInseeList({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Nom société" + (option.lstObligatoire.contains("nom_str") ? " *" : ""),
                    type: "",
                    value: option.value.nom_str,
                    onFocusIn: option.onFocusIn,
                    maxLength: 3000,
                    onValueChanged: function (value) {
                        dxNomSociete.element().css("background-color", "")
                        option.value.nom_str = value
                        if (option.onValueChanged) option.onValueChanged()
                        //if (!e.value) {
                        //    option.value.nom_str = ""
                        //} else {
                        //    option.value.nom_str = e.value.nom
                        //    disableValueChanged = true
                        //    if (e.value.siret) dxSiret.option("value", e.value.siret)
                        //    if (e.value.tvaintra) dxTvaIntra.option("value", e.value.tvaintra)
                        //    disableValueChanged = false
                        //}
                        //if (option.onSelectDataInsee) option.onSelectDataInsee(e)
                    },
                    onSelectItem: function (e) {
                        disableValueChanged = true
                        if (e.value.siret && dxSiret) dxSiret.option("value", e.value.siret)
                        if (e.value.tvaintra && dxTvaIntra) dxTvaIntra.option("value", e.value.tvaintra)
                        option.value.nom_str = e.value.nom
                        disableValueChanged = false
                        if (option.onValueChanged) option.onValueChanged()
                        if (option.onSelectDataInsee) option.onSelectDataInsee(e)
                    },
                    onContentReady: function (e) {
                        e.component.element().find(".dx-label").html("Nom société" + (option.lstObligatoire.contains("nom_str") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                        if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
                    }
                }).dxCtrlTextBoxInseeList("instance")
                break;
            case 2: case 3:
                dxNomSociete = $("<div style='padding:5px 0;'/>").appendTo(container).dxTextBox({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Nom société" + (option.lstObligatoire.contains("nom_str") ? " *" : ""),
                    type: "",
                    value: option.value.nom_str,
                    onFocusIn: option.onFocusIn,
                    maxLength: 3000,
                    onValueChanged: function (e) {
                        dxNomSociete.element().css("background-color", "")
                        option.value.nom_str = (e.value == null ? "" : e.value)
                        if (option.onValueChanged) option.onValueChanged()
                    },
                    onContentReady: function (e) {
                        e.component.element().find(".dx-label").html("Nom société" + (option.lstObligatoire.contains("nom_str") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                        if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
                    }
                }).dxTextBox("instance")
                break;
        }

        switch (parseInt(option.value.id_type_client)) {
            case 0: break;
            case 1:
                var $TableSocFrance = $("<table style='width:100%;'/>").appendTo(container)
                var $Tr = $("<tr/>").appendTo($TableSocFrance)
                var $Td = $("<td style='width:50%'/>").appendTo($Tr)
                var $TableSiret = $("<table style='width:100%;'/>").appendTo($Td)
                var $TrSiret = $("<tr/>").appendTo($TableSiret)
                var $TdWarning = $("<td style='width:0;display:none;font-size:200%;' title='Siret invalide. celui-ci sera ignoré.'><i class='fas fa-triangle-exclamation' style='color:red'></i></td>").appendTo($TrSiret)
                if (option.value.siret && option.value.siret.length > 0 && !isValidSiret(option.value.siret)) {
                    $TdWarning.show()
                    $TableSiret.css("background-color", "#ffcccc")
                }
                var $TdSaisieSiret = $("<td style='width:100%'/>").appendTo($TrSiret)
                dxSiret = $("<div style='margin:5px 0;'/>").appendTo($TdSaisieSiret).dxCtrlTextBoxInsee({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "Siret" + (option.lstObligatoire.contains("siret") ? " *" : ""),
                    placeholder: "",
                    type: "siret",
                    value: option.value.siret,
                    libSearch: option.value.nom_str,
                    onFocusIn: option.onFocusIn,
                    onDemandeLibSearch: function () {
                        return option.value.nom_str
                    },
                    onValueChanged: function (e) {
                        dxSiret.element().css("background-color", "")
                        if (e.value == null || e.value.length == 0) {
                            $TdWarning.hide()
                            $TableSiret.css("background-color", "")
                            option.value.siret = ""
                        } else {
                            if (!isValidSiret(e.value)) {
                                $TdWarning.show()
                                $TableSiret.css("background-color", "#ffcccc")
                                option.value.siret = ""
                                mNotify("Le siret saisie est invalide. il sera ignoré.", "error", 6000)
                            } else {
                                $TdWarning.hide()
                                $TableSiret.css("background-color", "")
                                option.value.siret = e.value
                            }
                        }
                        if (!disableValueChanged && option.onValueChanged) option.onValueChanged()
                    },
                    onContentReady: function (e) {
                        e.component.element().find(".dx-label").html("Siret" + (option.lstObligatoire.contains("siret") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                        if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
                    }
                }).dxCtrlTextBoxInsee("instance")
                var $Td = $("<td style='width:50%'/>").appendTo($Tr)
                dxTvaIntra = $("<div style='margin:5px 0;'/>").appendTo($Td).dxCtrlTextBoxInsee({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "N° TVA intracommunautaire" + (option.lstObligatoire.contains("tvaintra") ? " *" : ""),
                    placeholder: "",
                    type: "tvaintra",
                    value: option.value.tvaintra,
                    libSearch: option.value.nom_str,
                    onFocusIn: option.onFocusIn,
                    onDemandeLibSearch: function () {
                        return option.value.nom_str
                    },
                    onValueChanged: function (e) {
                        dxTvaIntra.element().css("background-color", "")
                        if (e.value == null || e.value.length == 0) {
                            option.value.tvaintra = ""
                        } else {
                            option.value.tvaintra = e.value
                        }
                        if (!disableValueChanged && option.onValueChanged) option.onValueChanged()
                    },
                    onContentReady: function (e) {
                        //e.component.element().find(".dx-label").html("N° TVA intracommunautaire" + (option.lstObligatoire.contains("tvaintra") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                        if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
                    }
                }).dxCtrlTextBoxInsee("instance")
                break;
            case 2:
                dxTvaIntra = $("<div style='margin:5px 0;'/>").appendTo(container).dxTextBox({
                    bddCtrl: option.bddCtrl,
                    labelMode: "floating",
                    label: "N° TVA intracommunautaire" + (option.lstObligatoire.contains("tvaintra") ? " *" : ""),
                    placeholder: "",
                    value: option.value.tvaintra,
                    onFocusIn: option.onFocusIn,
                    onValueChanged: function (e) {
                        if (e.value == null || e.value.length == 0) {
                            option.value.tvaintra = ""
                        } else {
                            option.value.tvaintra = e.value
                        }
                        if (!disableValueChanged && option.onValueChanged) option.onValueChanged()
                    },
                    onContentReady: function (e) {
                        e.component.element().find(".dx-label").html("N° TVA intracommunautaire" + (option.lstObligatoire.contains("tvaintra") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                    }
                }).dxTextBox("instance")
                break;
            case 3:
                break;
        }
    }

    this.mUpdate = function () { mConstruit() }

    this.mColorObligatoire = function () {
        if (dxNomSociete) dxNomSociete.element().css("background-color", "")
        if (dxSiret) dxSiret.element().css("background-color", "")
        if (dxTvaIntra) dxTvaIntra.element().css("background-color", "")

        var lstCtrlOblig = []
        if (option.lstObligatoire.contains("nom_str") && (!dxNomSociete.option("value") || dxNomSociete.option("value").length == 0)) {
            dxNomSociete.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxNomSociete)
        }
        if (option.lstObligatoire.contains("siret") && dxSiret && (!dxSiret.option("value") || dxSiret.option("value").length == 0)) {
            dxSiret.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxSiret)
        }
        if (option.lstObligatoire.contains("tvaintra") && dxTvaIntra && (!dxTvaIntra.option("value") || dxTvaIntra.option("value").length == 0)) {
            dxTvaIntra.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxTvaIntra)
        }
        return lstCtrlOblig
    }

    this.mReload = function () {
        mConstruit()
    }

    this.element = function () { return container; }
    this.focus = function () { dx.focus() }

    mConstruit();
}